var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61847 16.3183V13.7625C5.61846 13.1149 6.14509 12.5888 6.79739 12.5847H9.19254C9.84776 12.5847 10.3789 13.112 10.3789 13.7625V16.3109C10.3789 16.8726 10.8354 17.3291 11.4011 17.3331H13.0352C13.7984 17.3351 14.531 17.0355 15.0713 16.5004C15.6117 15.9654 15.9154 15.2388 15.9154 14.4811V7.22138C15.9153 6.60933 15.6421 6.02876 15.1692 5.63609L9.61785 1.22839C8.64746 0.457439 7.26151 0.482344 6.31986 1.28766L0.887875 5.63609C0.392648 6.01719 0.0966582 6.59947 0.0820312 7.22138V14.4737C0.0820313 16.0529 1.37152 17.3331 2.96218 17.3331H4.55894C4.83134 17.3351 5.09327 17.2291 5.28659 17.0385C5.47991 16.848 5.58864 16.5887 5.58863 16.3183H5.61847Z",
    fill: "#BF3535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.45a8e6c8f118023ca0cda1dca1cec6c2.svg";
export { ForwardRef as ReactComponent };